var map = {
	"./de-DE.json": [
		"3f18",
		"lang-[lang]0~dcedac1b"
	],
	"./en-EN.json": [
		"bf83",
		"lang-[lang]1~cbdb3581"
	],
	"./fr-FR.json": [
		"ff10",
		"lang-[lang]2~2a430537"
	],
	"./ru-RU.json": [
		"a158",
		"lang-[lang]3~c34eae3f"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8825";
module.exports = webpackAsyncContext;